// extracted by mini-css-extract-plugin
export default {"societyImage":"ArticleCard_societyImage__6zgWc"};